//import Vue from 'vue'
const state = {
    title: null,
    text: null,
    css: null,
    bar: 99
  }
  
  // getters
  const getters = {}
  
  // actions
  const actions = {
    showMessage ({ commit }, data) {
      commit('showMessage', data)
      commit('hideMessage')
    }
  }
  
  // mutations
  const mutations = {
    showMessage (state, playload) {
      const { title, css, text } = playload
      state.title = title
      state.css = css
      state.text = text
    },
    hideMessage (state) {
      var id = setInterval(frame, 15)
      var width = state.bar
      function frame () {
        if (width == 0) {
          clearInterval(id)
          setTimeout(() => {
            state.title = null
            state.css = null
            state.text = null
            state.bar = 100
          }, 1000)
        } else {
          width--
          state.bar = width
        }
      }
    }
  }
  
  export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
  }
  